module.exports = __webpack_public_path__ + "static/5-51f434ce3fba0a2f86c6069c10843ff6.png";